// GUARD capabilities. Merged into the matrix by mergeGrants at the gateway and
// in every portal, exactly like LIB_GRANTS (the anti-clobber law: never a spread).
//
//   guard:verify — scan a credential and see the verdict (the door desk)
//
// The `guard` role holds ONLY guard capabilities. That is what makes "a guard
// signs in and sees just their module" fall out of buildNav with no special
// case: every LIB and FIN nav item carries a perm, so all of them are filtered
// away and their modules collapse to nothing.
import type { RoleGrants } from "@erp/auth-kit/rbac";

export const GUARD_GRANTS: RoleGrants = {
  owner: ["guard:*"],
  admin: ["guard:*"],
  guard: ["guard:verify"],
  // The desk staff can also look someone up — the same door question gets asked
  // at the counter when a card will not scan.
  librarian: ["guard:verify"],
};

/** Any one of these admits a session to the guard desk. */
export const GUARD_CONSOLE_PERMS = ["guard:verify"] as const;
